// noinspection JSUnusedLocalSymbols

import Axios from "axios";
import {clearFeedbacksByNameV2, clearInputsByName, getInputsByNameV2} from "../forms";
import {interceptValidationErrors, noValidationErrorsLeft} from "./validationErrors/utils";
import handleAjaxErrorV2 from "../handleAjaxErrorV2";


class Form {
    /**
     * @param {BaseForm.FormConfig} config
     */
    constructor(config) {
        this.config = config;
        /** @type {import('../forms/validationErrors/utils').ValidationFilter[]} */
        this.validationErrorsFilters = [];
    }

    getValues() {
        return getInputsByNameV2(this.config.formElement, this.config.fields);
    };

    clearFeedbacks() {
        return clearFeedbacksByNameV2(this.config.formElement);
    };

    clearInputs() {
        return clearInputsByName(this.config.formElement, this.config.fields)
    };

    getSubmitUrl() {
        return this.config.formElement.querySelector('input[name="submit_route"]').value;
    };

    submit() {
        this.clearFeedbacks();

        const valuesPromise = typeof this.getValuesAsync === 'function'
            ? Promise.resolve(this.getValuesAsync())
            : Promise.resolve(this.getValues());

        return valuesPromise.then((values) => {
            return Axios.post(this.getSubmitUrl(), values)
                .then(response => {
                    const data = response.data;

                    // noinspection JSUnresolvedReference
                    if (data.update_route) {
                        // Update submit route on form
                        this.config.formElement.querySelector('input[name="submit_route"]').value = data.update_route;
                    }

                    if (this.config.onSuccess) {
                        this.config.onSuccess(data);
                    }

                    return response;
                })
                .catch(error => {
                    // We may need to intercept validation errors and handle them
                    // ourselves before letting handleAjaxError receive them.
                    // We can use this.validationErrorFilters to add filters to handle them.
                    let interceptedValidationErrors = false;

                    // If we have filters, attempt to intercept validation errors
                    if (this.validationErrorsFilters.length > 0) {
                        interceptedValidationErrors = interceptValidationErrors(error, this.validationErrorsFilters);
                    }

                    // If we didnt intercept anything or there were errors lefts...
                    if (interceptedValidationErrors === false || noValidationErrorsLeft(error) === false) {
                        ///... default error handler
                        handleAjaxErrorV2(error, this.config.formElement)
                    }

                    // Keep error going
                    throw error;
                });
        });
    };
}

export {Form}
